import { render, staticRenderFns } from "./fbcheckboxes.vue?vue&type=template&id=55f01bea&"
import script from "./fbcheckboxes.vue?vue&type=script&lang=js&"
export * from "./fbcheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports